/// <amd-module name="Artifacts/Npm/commands/Restore" />

import { NpmActions } from "Artifacts/Npm/redux";
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createRestoreCommand = getRestoreCommandCreator(NpmActions.restore);
